import classNames from 'classnames';
import { UnderlyingInfo } from 'components/shared/UnderlyingInfo/UnderlyingInfo';
import type { Underlying } from 'models/underlying';
import { FC, ReactNode, useMemo } from 'react';
import styled from 'styled-components';

export interface DataProps {
  children: ReactNode;
  shouldDisplayCode?: boolean;
  enableResponsive?: boolean;
  underlying: Underlying;
  maxWidth?: number;
}

const LongStyledSpan = styled.span<{ $maxWidth: number }>`
  max-width: ${props => props.$maxWidth}px !important;
`;

export const Data: FC<DataProps> = ({
  children,
  shouldDisplayCode = false,
  underlying,
  enableResponsive,
  maxWidth = 440,
}) => {
  const underlyingTitle = useMemo(() => {
    if (typeof children === 'string') {
      return children;
    }
    return '';
  }, [children]);

  return (
    <td
      className={classNames('p-2 align-middle', {
        'd-none d-xxxl-table-cell': enableResponsive,
      })}
      data-e2e="selected-underlying-item-info border"
      data-column="name"
    >
      <div
        className="w-100 pe-2 d-flex flex-row justify-content-between flex-nowrap align-items-center pt-1"
        data-e2e="selected-underlying-item-name"
      >
        <LongStyledSpan
          $maxWidth={maxWidth}
          className="d-inline-block flex-grow-1 align-items-center justify-content-between text-truncate"
          title={underlyingTitle}
        >
          {children}
        </LongStyledSpan>
        {shouldDisplayCode && <UnderlyingInfo underlying={underlying} />}
      </div>
    </td>
  );
};
